module.exports = __webpack_public_path__ + "img/pago.0c38c93c.png";